import { composeDecorators } from 'draft-js-plugins-editor';
import createFocusPlugin from 'draft-js-focus-plugin';

import {
    createHeadlinesPlugin,
    createHorizontalLinePlugin,
    createImagePlugin,
    createParagraphsPlugin,
    createResizablePlugin,
    createRemovalCommandsPlugin
} from '.';
import { wysiwygPlugins } from '../constants';

const getPlugins = (disabledPlugins = []) => {
    const plugins = [];
    let focusPlugin;
    let resizablePlugin;

    if (!disabledPlugins.includes(wysiwygPlugins.headlines)) {
        plugins.push(createHeadlinesPlugin());
    }
    if (!disabledPlugins.includes(wysiwygPlugins.horizontalLine)) {
        plugins.push(createHorizontalLinePlugin());
    }
    if (!disabledPlugins.includes(wysiwygPlugins.focus)) {
        focusPlugin = createFocusPlugin({ theme: { focused: 'onsolve-wysiwyg-editor__block--focused' } });
        plugins.push(focusPlugin);
    }
    if (!disabledPlugins.includes(wysiwygPlugins.resizablePlugin)) {
        resizablePlugin = createResizablePlugin({ decorator: focusPlugin.decorator });

        plugins.push(resizablePlugin);
    }
    if (!disabledPlugins.includes(wysiwygPlugins.image)) {
        plugins.push(
            createImagePlugin({
                decorator: !disabledPlugins.includes(wysiwygPlugins.resizablePlugin)
                    ? composeDecorators(resizablePlugin.decorator)
                    : null
            })
        );
    }
    if (!disabledPlugins.includes(wysiwygPlugins.paragraphs)) {
        plugins.push(createParagraphsPlugin());
    }
    if (!disabledPlugins.includes(wysiwygPlugins.removalCommands)) {
        plugins.push(createRemovalCommandsPlugin());
    }

    return plugins;
};

export default getPlugins;
